<template>
  <div class="body_class">
    <!-- 登录界面容器 -->
    <div class="container">
      <div class="login-box">
        <!-- logo图 -->
        <!-- <img
          src="http://qiaokun.yuepong.com/login-logo.png"
          class="login-logo"
          alt=""
        /> -->
        <!-- 图片 -->
        <div class="loginBoxImg"></div>
        <!-- 表单 -->
        <div class="loginBoxForm">
          <div class="loginBoxFormClass">
            <!-- 登录图片 -->
            <div class="loginBoxTop">
              <img src="../assets/login/dl.png" class="loginBoxTopImg" alt="" />
              <div class="loginBoxTopSpan">欢迎使用悦朋软件</div>
            </div>
            <!-- 表单区域 -->
            <div class="loginBoxMiddle">
              <el-form
                :model="loginForm"
                :rules="loginFormRules"
                ref="loginFormRef"
              >
                <el-form-item prop="username">
                  <el-input
                    v-model.trim="loginForm.username"
                    placeholder="请输入账号"
                    class="usernameInput"
                  >
                    <img
                      src="../assets/login/icon2.png"
                      class="userIconClass"
                      slot="prefix"
                      alt=""
                    />
                  </el-input>
                </el-form-item>
                <!-- 密码框 -->
                <el-form-item prop="password">
                  <el-input
                    v-model.trim="loginForm.password"
                    type="password"
                    placeholder="请输入密码"
                    class="passwordInput"
                    @keyup.enter.native="loginBtn"
                  >
                    <img
                      src="../assets/login/icon.png"
                      class="userIconClass"
                      slot="prefix"
                      alt=""
                    />
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-checkbox class="keepPasswordClass" v-model="keepPassword"
                    >记住密码</el-checkbox
                  >
                </el-form-item>
                <el-form-item>
                  <img
                    @click="loginBtn"
                    src="../assets/login/btn.png"
                    class="loginBoxMiddleBtn"
                    alt=""
                  />
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <!-- 公司信息 -->
      <div class="bottom">
        <span
          >Copyright © 2016-2022 悦朋智能科技有限公司 All rights reserved</span
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 登录参数
      loginForm: {
        username: '',
        password: ''
      },
      // 登录校验
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      // 记住密码
      keepPassword: false
    }
  },
  mounted() {
    this.getCookie() // 读取cookie
  },
  methods: {
    /**
     * 登录方法
     *
     */
    loginBtn() {
      this.$refs.loginFormRef.validate((valid) => {
        if (valid) {
          // 获取登录接口
          this.$api.postLoginApi.postLogin(this.loginForm).then((res) => {
            console.log('登录', res)
            sessionStorage.setItem('token', res.data.token)
            if (res.errno === '200000') {
              this.$router.push('/home') // 跳转页面
              this.$message.success('登录成功')
            }
          })
        }
      })
      // 判断记住密码
      if (this.keepPassword) {
        this.setCookie(this.loginForm.username, this.loginForm.password, 7)
      } else {
        this.clearCookie() // 清除数据
      }
    },
    /**
     * 记住密码
     *
     */
    // 设置cookie
    setCookie(username, password, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie =
        'userName' + '=' + username + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie =
        'userPwd' + '=' + password + ';path=/;expires=' + exdate.toGMTString()
    },
    getCookie() {
      console.log('存储0000')
      if (document.cookie.length > 0) {
        this.keepPassword = true
        var arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            this.loginForm.username = arr2[1] // 保存到保存数据的地方
          } else if (arr2[0] === 'userPwd') {
            this.loginForm.password = arr2[1]
          }
        }
      }
    },
    // 清除cookie
    clearCookie: function () {
      this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
    }
  }
}
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.body_class {
  height: 100%;
}
// 登录界面容器
.container {
  background: url('../assets/login/bg.png');
  // height: 100vh;
  margin-left: -1px;
  height: var(--height118, 100vh);
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
// 表单区域
.login-box {
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-top: var(--marginTop, 120px);
  // padding-left: var(--paddingLeft);
  width: 1098px;
  height: 612px;
}
// 图片
.loginBoxImg {
  width: var(--width, 500.2px);
  height: var(--height, 612px);
  border-bottom-left-radius: 20px;
  border-top-left-radius: 20px;
  background-image: url('../assets/login/zu3.png');
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
// 表单右
.loginBoxForm {
  width: var(--width, 598px);
  height: var(--height, 612px);
  border-radius: 0 20px 20px 0;
  background: url('../assets/login/juxing5.png') no-repeat;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.loginBoxFormClass {
  padding-top: var(--paddingTop, 80px);
  padding-left: var(--paddingLeft, 65px);
}
// 登录图片
.loginBoxTop {
  margin-left: 10px;
  // 标题
  .loginBoxTopSpan {
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    // margin-left: 19px;
    margin-left: 85px;
    margin-top: -40px;
    // position: absolute;
  }
}
// 表单区域
.loginBoxMiddle {
  margin-top: 44px;
}
// 输入框
/deep/.el-input__inner {
  position: relative;
  right: 20px;
  height: 70px;
  border-radius: 30px;
  border: 2px solid #ccc;
  font-size: 26px;
}
// 登录按钮
.loginBoxMiddleBtn {
  width: var(--width);
  position: absolute;
  top: var(--top, 55px);
  cursor: pointer;
}
// 记住密码
.keepPasswordClass {
  margin-left: 15px;
  margin-top: 19px;
}
/deep/.el-checkbox__inner {
  width: 27px;
  height: 27px;
  display: inline-block;
  position: relative;
  border: 2px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  background-color: #fff;
  z-index: 1;
  transition: border-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46),
    background-color 0.25s cubic-bezier(0.71, -0.46, 0.29, 1.46);
}
/deep/.el-checkbox__inner::after {
  box-sizing: content-box;
  content: '';
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);
  width: 9px;
  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}
/deep/.el-checkbox__label {
  font-family: Microsoft YaHei;
  display: inline-block;
  padding-left: 10px;
  line-height: 19px;
  font-size: 20px;
  color: #666666;
}
// 公司信息
.bottom {
  width: 100%;
  font-family: Microsoft YaHei;
  position: absolute;
  height: 40px;
  bottom: var(--bottom, 17px);
  text-align: center;
  line-height: 40px;
  font-size: 18px;
  color: #fff;
}
// 图标样式
/deep/.el-input__icon {
  font-size: 25px;
  height: 100%;
  // width: 50px;
  text-align: center;
  transition: all 0.3s;
  line-height: 40px;
}
// 图标位置
.userIconClass {
  padding-top: 20px;
  padding-left: 10px;
}
// 输入框文字
/deep/.el-input--prefix .el-input__inner {
  padding-left: 80px;
}
// 输入框大小
.passwordInput {
  // width: var(--width, 480px);
  margin-top: 38px;
}
@media screen and (max-height: 801px) {
  .container {
    --height118: 100vh;
  }
  .login-box {
    --marginTop: 5px;
    // --paddingLeft: 100px;
  }
  .loginBoxImg {
    // --width: 420.2px;
    // --height: 512px;
    width: 40%;
    height: 88%;
  }
  .loginBoxForm {
    // --width: 498px;
    // --height: 512px;
    --width: 46%;
    --height: 88%;
  }
  .loginBoxFormClass {
    --paddingTop: 48px;
    --paddingLeft: 67px;
  }
  .usernameInput {
    --width: 380px;
  }
  .passwordInput {
    --width: 380px;
  }
  .loginBoxMiddleBtn {
    --width: 95%;
    --top: 33px;
  }
  .bottom {
    --bottom: 6px;
  }
}
</style>
